
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
export default [
  {
    name: "attestation-key-id",
    path: "/attestation/:key()/:id()",
    component: () => import("/app/app/pages/attestation/[key]/[id].vue")
  },
  {
    name: "entity-key-id",
    path: "/entity/:key()/:id()",
    component: () => import("/app/app/pages/entity/[key]/[id].vue")
  },
  {
    name: "group-key-id",
    path: "/group/:key()/:id()",
    component: () => import("/app/app/pages/group/[key]/[id].vue")
  },
  {
    name: "liste-classe-key-id",
    path: "/liste-classe/:key()/:id()",
    component: () => import("/app/app/pages/liste-classe/[key]/[id].vue")
  },
  {
    name: "recu-print-key-id",
    path: "/recu-print/:key()/:id()",
    component: () => import("/app/app/pages/recu-print/[key]/[id].vue")
  },
  {
    name: "relance-key-id",
    path: "/relance/:key()/:id()",
    component: () => import("/app/app/pages/relance/[key]/[id].vue")
  },
  {
    name: "releve-notes-key-id",
    path: "/releve-notes/:key()/:id()",
    component: () => import("/app/app/pages/releve-notes/[key]/[id].vue")
  },
  {
    name: "entity-key",
    path: "/entity/:key()",
    component: () => import("/app/app/pages/entity/[key]/index.vue")
  },
  {
    name: "module-key",
    path: "/module/:key()",
    component: () => import("/app/app/pages/module/[key].vue")
  },
  {
    name: "report-key",
    path: "/report/:key()",
    component: () => import("/app/app/pages/report/[key].vue")
  },
  {
    name: "guide",
    path: "/guide",
    component: () => import("/app/app/pages/guide.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "recu-inscription",
    path: "/recu-inscription",
    component: () => import("/app/app/pages/recu-inscription.vue")
  },
  {
    name: "relance-groupee",
    path: "/relance-groupee",
    component: () => import("/app/app/pages/relance-groupee.vue")
  },
  {
    name: "wizard",
    path: "/wizard",
    component: () => import("/app/app/pages/wizard.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  }
]